import Spreadsheet from './Spreadsheet';

export default Spreadsheet;
